import {
    AiNurseQuestionResponse,
    AiNurseRequest,
} from '@/features/booking/shared/model/types';
import { fetchWithTimeout } from '@/shared/fetchWithTimeout';

export const fetchAiNurseQuestion = async (
    aiNurseRequest: AiNurseRequest,
): Promise<AiNurseQuestionResponse> => {
    return fetchWithTimeout<AiNurseQuestionResponse>(
        '/api/ai/ai-nurse/question',
        'POST',
        aiNurseRequest,
        5000,
    );
};
